import { Heading } from '@tiptap/extension-heading';
// import { mergeAttributes } from '@tiptap/core';

const CustomHeading = Heading.extend({
    // Définissez l'attribut `id`
 renderHTML({ node, HTMLAttributes }) {
    const level = node.attrs.level
    const marginStyle = level === 1 ? 'margin-bottom: 1em;' : 'margin: 1em 0;'

    return [
      `h${level}`,
      {
        ...HTMLAttributes,
        style: `${HTMLAttributes.style || ''} ${marginStyle}`.trim(),
      },
      0,
    ]
  },
    addAttributes() {
        return {
            id: {
                default: null,
                parseHTML: element => element.getAttribute('id'), // Récupère l'id à partir du DOM
                renderHTML: attributes => {
                    if (!attributes.id) {
                        return {}
                    }
                    return {
                        id: attributes.id // Applique l'id au DOM lors du rendu
                    }
                },
            },
        }
    },
})

export default CustomHeading;